import http from '@axios'
// import { addUser } from "@/services/users";
import {getUserToken, getUserData} from "@/helpers/Utils";

const endpoint = `/member`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": "listMember"
  },
  "data": {}
};

const lookupMember = (data) => {
  const user = getUserData();
  body.req.op = 'lookupMember';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  if (!data) {
    delete body['data']
  }
  return http.post(endpoint, body);
}

const listMember = (data) => {
  const user = getUserData();
  body.req.op = 'listMember';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  if (!data) {
    delete body['data']
  }
  return http.post(endpoint, body);
}

const findMemberBy = (type, data) => {
  const user = getUserData();
  body.req.op = type;
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data
  return http.post(endpoint, body)
}

const getMemberByID = (id) => {
  body.req.op = 'getMember';
//  body.req.user = user.id;
//  body.req.username = user.username;
  body.req.token = getUserToken();
  body.data = {
    id,
  }
  return http.post(endpoint, body);
}

const addMember = (data) => {
  let defaultData = {
    company_name: "",
    NPWP: "",
    NIB: "",
    member_since: "",
    expiry: "",
    npwp_img: "",
    nib_img: "",
  }
  const user = getUserData();
  body.req.op = 'addMember';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = {...defaultData, ...data};
  return http.post(endpoint, body);
}

const updateMember = (data) => {
  let defaultData = {
    id: null,
    company_name: "",
    NPWP: "",
    NIB: "",
    member_since: "",
    expiry: "",
    npwp_img: "",
    nib_img: "",
  }
  const user = getUserData();
  body.req.op = 'updMember';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = {...defaultData, ...data};
  return http.post(endpoint, body);
}

const deleteMember = (id) => {
  const user = getUserData();
  body.req.op = 'delMember';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = { id }
  return http.post(endpoint, body);
}

const setMemberStatus = (id, status) => {
  const user = getUserData();
  body.req.op = 'setMemberStatus';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = { id, status, }
  return http.post(endpoint, body);
}

const renewMember = ({id, expire, renewal}) => {
  const user = getUserData();
  body.req.op = 'renewMember';

  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = { id, expire, renewal, }
  return http.post(endpoint, body);
}

const registerMember = (data) => {
  let defaultData = {
    company_name: data.company_name,
    NPWP: data.NPWP,
    npwp_img: data.npwp_img,
    NIB: data.NIB,
    nib_img: data.nib_img,
    username: data.username,
    email: data.email,
  }
  body.req.op = 'register';
  body.data = {...defaultData, ...data};
  return http.post(endpoint, body);
}
/*
const registerMember = async  (data) => {
  // prepare add member data first

  let addMemberData = {
    company_name: data.company_name,
    NPWP: data.NPWP,
    NIB: data.NIB,
    member_since: "",
    expiry: "",
    npwp_img: data.npwp_img,
    nib_img: data.nib_img,
  }

  const {data: { data: {member} }} = await addMember(addMemberData);

  const userData = {
    member: member.id,
    username: data.username,
    level: 2,
    user_type: 2,
    user_mail: data.user_mail,
    user_telegram: null,
  }

  return addUser(userData);

  // body.req.op = 'registerMember';
  // body.data = data;
  // return http.post(endpoint, body);
}
*/
const getDashStats = (data) => {
  const user = getUserData();
  body.req.op = 'getDashStats';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}


export {
  lookupMember, listMember, findMemberBy,
  getMemberByID, addMember,
  updateMember, deleteMember,
  setMemberStatus, renewMember,
  registerMember, getDashStats,
};
